export default "__VITE_ASSET__f6ea4440__"